import { classNames } from "primereact/utils";
import styles from "./ServiceCategoryHeader.module.scss";

interface IServiceCategoryHeaderProps {
  name: string;
  serviceCount: number;
  className?: string;
  countLabelSingular?: string;
  countLabelPlural?: string;
}

export const ServiceCategoryHeader = ({
  name,
  serviceCount,
  className,
  countLabelSingular = "услуга",
  countLabelPlural = "услуги",
}: IServiceCategoryHeaderProps) => {
  return (
    <div className={classNames(styles.header, className)}>
      <div className={styles.headerContent}>
        <span className={styles.categoryName}>{name}</span>
        <span className={styles.serviceCount}>
          {serviceCount} {serviceCount === 1 ? countLabelSingular : countLabelPlural}
        </span>
      </div>
    </div>
  );
};
